import React from 'react';
import { Layout } from '../components/common/Layout';
import { LearningJourneyTimeline } from '../components/learning-journey/LearningJourneyTimeline';
import { Map } from 'lucide-react';

const LearningJourneyPage: React.FC = () => {
  return (
    <Layout>
      <div className="bg-gradient-to-br from-primary-50 to-secondary-50 min-h-screen">
        {/* Header */}
        <div className="bg-white shadow-sm border-b border-neutral-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <div className="flex items-center space-x-4">
              <div className="p-3 bg-primary-100 rounded-lg">
                <Map className="w-8 h-8 text-primary" />
              </div>
              <div>
                <h1 className="text-3xl font-bold text-neutral-900">Your Learning Journey</h1>
                <p className="text-neutral-600 mt-1">
                  Track your progress, explore your knowledge coverage, and manage your path to AI mastery.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Timeline Content */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <LearningJourneyTimeline />
        </div>
      </div>
    </Layout>
  );
};

export default LearningJourneyPage;
